module.exports = __webpack_public_path__ + "img/836226.704d91dc.jpg";